
const state = {
  hidden: false,
  id: null,
  product_code: '',
  provider_price_list_item_id: undefined,
  title: '',
}

export const requiredFields = [
  { key: 'provider_price_list_item_id' },
  { key: 'title' },
]

export default state
